<template>
  <div class="crud_form_wrapper">
    <!-- Start:: Title -->
    <div class="form_title_wrapper">
      <h4>{{ $t("TITLES.editClient") }}</h4>
    </div>
    <div class="col-12 text-end">
      <v-btn @click="$router.go(-1)" style="color: #E1423D">
        <i class="fas fa-backward"></i>
      </v-btn>
    </div>
    <!-- End:: Title -->

    <!-- Start:: Single Step Form Content -->
    <div class="single_step_form_content_wrapper">
      <form @submit.prevent="validateFormInputs">
        <div class="row">
          <!-- Start:: Image Upload Input -->
          <base-image-upload-input
            :col="data.user_type === 'company' ? '4' : '12'"
            identifier="client_image"
            :placeholder="$t('PLACEHOLDERS.personalImage')"
            @selectImage="selectImage"
            :preSelectedImage="data.image.path"
          />
          <!-- End:: Image Upload Input -->

          <!-- Start:: Commercial Registration Image Upload Input -->
          <base-image-upload-input
            col="4"
            identifier="commercial_registration_image"
            :placeholder="$t('PLACEHOLDERS.commercial_registration_image') || 'Commercial Registration Image'"
            @selectImage="selectImage"
            :preSelectedImage="data.commercial_registration_image?.path"
            v-if="data.user_type === 'company'"
          />
          <!-- End:: Commercial Registration Image Upload Input -->

          <!-- Start:: Tax Number Image Upload Input -->
          <base-image-upload-input
            col="4"
            identifier="tax_number_image"
            :placeholder="$t('PLACEHOLDERS.tax_number_image') || 'Tax Number Image'"
            @selectImage="selectImage"
            :preSelectedImage="data.tax_number_image?.path"
            v-if="data.user_type === 'company'"
          />
          <!-- End:: Tax Number Image Upload Input -->

          <!-- Start:: Email Input -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.email')"
            v-model.trim="data.email"
            required
          />
          <!-- End:: Email Input -->
          <!-- Start:: Phone Input -->
          <base-input
            col="6"
            type="text"
            v-model="data.phone"
            :placeholder="$t('PLACEHOLDERS.phone')"
            required
          />
          <!-- End:: Phone Input -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.service_requester_name')"
            v-model.trim="data.client_name"
            required
          />
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.commercial_registration_number')"
            v-model.trim="data.commercial_registration_number"
            v-if="data.user_type === 'company'"
          />
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.tax_number')"
            v-model.trim="data.tax_number"
            v-if="data.user_type === 'company'"
          />
          <base-select-input
            col="6"
            :optionsList="regions"
            :placeholder="$t('PLACEHOLDERS.region')"
            v-model.trim="data.region"
            @input="onRegionChange"
            required
          />
          <base-select-input
            col="6"
            :optionsList="cities"
            :placeholder="$t('PLACEHOLDERS.city')"
            v-model.trim="data.city"
            @input="onCityChange"
            required
          />
          <base-select-input
            col="6"
            :optionsList="districts"
            :placeholder="$t('PLACEHOLDERS.district')"
            v-model.trim="data.district"
            required
          />
          <!-- <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.building_number')"
            v-model.trim="data.building_number"
          /> -->
          <!-- <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.postal_code')"
            v-model.trim="data.postal_code"
            v-if="data.user_type === 'company'"
          /> -->
          <!-- Start:: Address Input -->
          <base-input
            ref="phoneInput"
            col="12"
            type="text"
            :placeholder="$t('PLACEHOLDERS.address')"
            v-model.trim="data.address"
            required
          />
          <ChangableMapComponent
            :lat="parseFloat(data.latitude)"
            :lng="parseFloat(data.longitude)"
            @update:lat="data.latitude = $event"
            @update:lng="data.longitude = $event"
          />
          <!-- End:: Address Input -->
          <!-- Start:: Status Input -->
          <!-- <div class="input_wrapper switch_wrapper my-5">
            <v-switch
              color="green"
              :label="data.status ? $t('PLACEHOLDERS.active') : $t('PLACEHOLDERS.notActive')"
              v-model="data.status"
              hide-details
            ></v-switch>
          </div> -->
          <!-- End:: Status Input -->
          <div class="btn_wrapper">
            <base-button
              class="mt-2"
              styleType="primary_btn"
              :btnText="$t('BUTTONS.save')"
              :isLoading="isWaitingRequest"
              :disabled="isWaitingRequest"
            />
          </div>
          <!-- End:: Submit Button Wrapper -->
        </div>
      </form>
    </div>
    <!-- END:: Single Step Form Content -->
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import BasePhoneInput from "@/components/formInputs/BasePhoneInput.vue";
import ChangableMapComponent from "@/components/general/ChangableMapComponent";

export default {
  name: "EditClients",
  components: {
    BasePhoneInput,
    ChangableMapComponent,
  },
  data() {
    return {
      // Start:: Loader Control Data
      isWaitingRequest: false,
      // End:: Loader Control Data

      // Start:: Data Collection To Send
      data: {
        image: {
          path: null,
          file: null,
        },
        commercial_registration_image: {
          path: null,
          file: null,
        },
        tax_number_image: {
          path: null,
          file: null,
        },
        email: null,
        client_name: null,
        commercial_registration_number: null,
        tax_number: null,
        region: null,
        user_type: null,
        city: null,
        district: null,
        building_number: null,
        postal_code: null,
        address: null,
        latitude: null,
        longitude: null,
        phone: null,
        dial_code: null,
        status: null,
      },
      regions: [],
      cities: [],
      districts: [],
      key: "",
      // End:: Data Collection To Send
    };
  },
  computed: {
    statusOptions() {
      return [
        { id: 1, name: this.$t("STATUS.active"), value: "active" },
        { id: 2, name: this.$t("STATUS.notActive"), value: "inactive" },
      ];
    },
  },
  methods: {
    async getRegions() {
      try {
        let res = await this.$axios({
          method: "GET",
          url: `regions?paginate=false&filter[is_active]=true`,
        });
        this.regions = res.data.data;
      } catch (error) {
        console.log(error.response?.data?.message || error.message);
      }
    },
    async getCities(regionId = null) {
      try {
        const url = regionId
          ? `cities?paginate=false&filter[is_active]=true&filter[region_id]=${regionId}`
          : `cities?paginate=false&filter[is_active]=true`;
        let res = await this.$axios({
          method: "GET",
          url: url,
        });
        this.cities = res.data.data;
      } catch (error) {
        console.log(error.response?.data?.message || error.message);
      }
    },
    async getDistricts(cityId = null) {
      try {
        const url = cityId
          ? `districts?paginate=false&filter[is_active]=true&filter[city_id]=${cityId}`
          : `districts?paginate=false&filter[is_active]=1`;
        let res = await this.$axios({
          method: "GET",
          url: url,
        });
        this.districts = res.data.data;
      } catch (error) {
        console.log(error.response?.data?.message || error.message);
      }
    },
    onRegionChange() {
      this.data.city = null;
      this.data.district = null;
      this.cities = [];
      this.districts = [];
      if (this.data.region?.id) {
        this.getCities(this.data.region.id);
      }
    },
    onCityChange() {
      this.data.district = null;
      this.districts = [];
      if (this.data.city?.id) {
        this.getDistricts(this.data.city.id);
      }
    },
    // Start:: Select Upload Image
    selectImage(selectedImage) {
      if (selectedImage.identifier === "client_image") {
        this.data.image = selectedImage;
      } else if (selectedImage.identifier === "commercial_registration_image") {
        this.data.commercial_registration_image = selectedImage;
      } else if (selectedImage.identifier === "tax_number_image") {
        this.data.tax_number_image = selectedImage;
      }
    },
    // End:: Select Upload Image
    // Start:: validate Form Inputs
    validateFormInputs() {
      this.isWaitingRequest = true;
      this.submitForm();
    },
    // End:: validate Form Inputs
    // start show data
    async showClient() {
      try {
        let res = await this.$axios({
          method: "GET",
          url: `users/${this.$route.params?.id}?include=roles,region,city,district`,
        });
        const user = res.data.data;
        this.data.user_type = user.user_type;
        this.data.client_name = user.name;
        this.data.image.path = user.avatar;
        this.data.email = user.email;
        this.data.phone = user.phone;
        this.data.commercial_registration_number = user.commercial_registration_number;
        this.data.tax_number = user.tax_number;
        this.data.address = user.address_details;
        this.data.latitude = user.latitude;
        this.data.longitude = user.longitude;
        this.data.building_number = user.building_number;
        this.data.postal_code = user.postal_code;
        if (user.commercial_registration_image) {
          this.data.commercial_registration_image.path = user.commercial_registration_image;
        }
        if (user.tax_number_image) {
          this.data.tax_number_image.path = user.tax_number_image;
        }
        this.data.status = user.status || "active";
        
        // Set region and load cities
        if (user.region) {
          this.data.region = user.region;
          await this.getCities(user.region.id);
        }
        
        // Set city and load districts
        if (user.city) {
          this.data.city = user.city;
          await this.getDistricts(user.city.id);
        }
        
        // Set district
        if (user.district) {
          this.data.district = user.district;
        }
        
        // Extract phone code if available
        if (user.phone) {
          const phoneMatch = user.phone.match(/^\+(\d+)/);
          if (phoneMatch) {
            this.key = phoneMatch[1];
          }
        }
      } catch (error) {
        this.loading = false;
        console.log(error?.response?.data?.message);
      }
    },
    // end show data
    // Start:: Submit Form
    async submitForm() {
      const REQUEST_DATA = new FormData();
      if (this.data.image.file) {
        REQUEST_DATA.append("avatar", this.data.image.file);
      }
      if (this.data.commercial_registration_image.file) {
        REQUEST_DATA.append("commercial_registration_image", this.data.commercial_registration_image.file);
      }
      if (this.data.tax_number_image.file) {
        REQUEST_DATA.append("tax_number_image", this.data.tax_number_image.file);
      }
      if (this.data.client_name) {
        REQUEST_DATA.append("name", this.data.client_name);
      }
      if (this.data.email) {
        REQUEST_DATA.append("email", this.data.email);
      }
      if (this.data.phone) {
        REQUEST_DATA.append("phone", this.data.phone);
      }
      if (this.data.region?.id) {
        REQUEST_DATA.append("region_id", this.data.region.id);
      }
      if (this.data.city?.id) {
        REQUEST_DATA.append("city_id", this.data.city.id);
      }
      if (this.data.district?.id) {
        REQUEST_DATA.append("district_id", this.data.district.id);
      }
      if (this.data.address) {
        REQUEST_DATA.append("address_details", this.data.address);
      }
      if (this.data.latitude) {
        REQUEST_DATA.append("latitude", this.data.latitude);
      }
      if (this.data.longitude) {
        REQUEST_DATA.append("longitude", this.data.longitude);
      }
      if (this.data.commercial_registration_number) {
        REQUEST_DATA.append("commercial_registration_number", this.data.commercial_registration_number);
      }
      if (this.data.tax_number) {
        REQUEST_DATA.append("tax_number", this.data.tax_number);
      }
      if (this.data.building_number) {
        REQUEST_DATA.append("building_number", this.data.building_number);
      }
      if (this.data.postal_code) {
        REQUEST_DATA.append("postal_code", this.data.postal_code);
      }
      if (this.data.status) {
        REQUEST_DATA.append("status", this.data.status);
      }

      try {
        await this.$axios({
          method: "PATCH",
          url: `users/${this.$route.params.id}`,
          data: REQUEST_DATA,
        });
        this.isWaitingRequest = false;
        this.$message.success(this.$t("MESSAGES.editedSuccessfully"));
        this.$router.push({ path: "/clients/all" });
      } catch (error) {
        this.isWaitingRequest = false;
        this.$message.error(error.response?.data?.message || error.message);
      }
    },
    // End:: Submit Form
  },

  async created() {
    // Start:: Fire Methods
    await this.getRegions();
    await this.showClient();
    // End:: Fire Methods;
  },
};
</script>
